import { ImgHTMLAttributes } from "react";

type PictureImport = {
  sources: Record<string, string>;
  img: { src: string; w: number; h: number };
};

interface ResponsiveImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "srcSet"> {
  picture: PictureImport;
  sizes?: string;
  eager?: boolean;
  fetchPriority?: "high" | "low" | "auto";
}

/**
 * Renders a <picture> with AVIF/WebP/fallback sources generated by vite-imagetools.
 * Import format: `import pic from "@/assets/x.jpg?w=640;1024;1600;1920&format=avif;webp;jpg&as=picture"`.
 */
const ResponsiveImage = ({
  picture,
  sizes = "100vw",
  eager = false,
  fetchPriority,
  alt = "",
  className,
  ...rest
}: ResponsiveImageProps) => {
  return (
    <picture>
      {Object.entries(picture.sources).map(([format, srcSet]) => (
        <source key={format} type={`image/${format}`} srcSet={srcSet} sizes={sizes} />
      ))}
      <img
        src={picture.img.src}
        width={picture.img.w}
        height={picture.img.h}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        // @ts-expect-error fetchpriority is a valid HTML attribute
        fetchpriority={fetchPriority}
        alt={alt}
        className={className}
        {...rest}
      />
    </picture>
  );
};

export default ResponsiveImage;
